/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.lineitems.rpc.LineItemCreateUtilityRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getLineItemPropertiesFromProductBatchRpc = {
  serviceName: 'com.hubspot.lineitems.rpc.LineItemCreateUtilityRpc',
  rpcName: 'getLineItemPropertiesFromProductBatch',
  auth: 'app',
  fingerprint: 'UqCz6sJi7Q82aBdEJmUyP5QAI0lFi1oR',
  na1Only: false,
  isStreaming: false
};
export const getLineItemPropertiesFromProductMaxBatchSizeRpc = {
  serviceName: 'com.hubspot.lineitems.rpc.LineItemCreateUtilityRpc',
  rpcName: 'getLineItemPropertiesFromProductMaxBatchSize',
  auth: 'app',
  fingerprint: 'xR6UlptK0rObKs9zYasblJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false
};